<template>
  <div id="visual-detail" class="modal-form" @click.self="onClickModalOverlay">
    <!-- <PerfectScrollbar class="ps"> -->
    <div class="box-detail">
      <div class="content-box justify-content-between">
        <div class="d-flex flex-column">
          <p>
            <a class="report-link" href="#">Report</a>
          </p>
          <div class="img mb-2 frame">
            <img :src="images[index].media.url" />
          </div>
          <div class="connected-experiences">
            <ExperiencePicker
              :contentId="images[index].id"
              buttonColor="#707070"
            />
          </div>
        </div>
        <div class="description-box d-flex flex-column">
          <perfect-scrollbar class="ps">
            <p class="title">
              Image approval <img class="help-link" :src="icons.help" />
            </p>
            <div class="description">
              <div v-if="images[index].network" class="network-name">
                Channal: <strong>{{ images[index].network }}</strong>
              </div>
              <div v-if="images[index].author" class="author-info">
                <div class="author-picture">
                  <img :src="images[index].author.picture" />
                </div>
                <div>
                  <div class="author-name">{{ images[index].author.name }}</div>
                  <div class="post-date">
                    Posted {{ getHumanDate(images[index].postCreated) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="description2">
              <div
                v-if="images[index].content"
                v-html="images[index].content"
              ></div>
            </div>

            <div class="description2">
              <p>Display on... <img class="help-link" :src="icons.help" /></p>
              <ul>
                <li>This function is under development</li>
              </ul>
            </div>
            <div class="description2">
              <p>Ownership <img class="help-link" :src="icons.help" /></p>
              <ul>
                <li>This function is under development</li>
              </ul>
            </div>
            <!-- <div class="description2">
              <p>Distribution <img class="help-link" :src="icons.help" /></p>
              <ul>
                <li>
                  <img :src="icons.icon01" class="mr-1" /> Mongolia.travel
                </li>
                <li><img :src="icons.icon02" class="mr-1" /> Mongolia Taste</li>
                <li>
                  <img :src="icons.icon03" class="mr-1" /> Mongolia Tourism
                  Mobile Application
                </li>
              </ul>
            </div> -->
          </perfect-scrollbar>
          <div class="content-placeholder" />
          <div
            class="update-status-buttons button-group justify-content-between"
          >
            <button
              class="btn justify-center align-center"
              :class="{
                'btn-primary': images[index].status === 'approved',
                'btn-default': images[index].status !== 'approved',
              }"
              @click="updateStatus('approved')"
            >
              <img class="icon-button" :src="icons.icon04" />APPROVE AND SHOW
            </button>
            <button
              class="btn d-flex justify-center align-center"
              :class="{
                'btn-info': images[index].status === 'pending',
                'btn-default': images[index].status !== 'pending',
              }"
              @click="updateStatus('pending')"
            >
              <img class="icon-button" :src="icons.icon05" />UNDECIDED
            </button>
            <button
              class="btn d-flex justify-center align-center"
              :class="{
                'btn-danger': images[index].status === 'rejected',
                'btn-default': images[index].status !== 'rejected',
              }"
              @click="updateStatus('rejected')"
            >
              <img class="icon-button" :src="icons.icon06" />HIDE
            </button>
          </div>
        </div>
      </div>
      <button class="close" @click="close()">Close</button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ExperiencePicker from "@/components/ExperiencePicker";
import help from "@/assets/images/icons/ew-icon_help.svg";
import icon01 from "@/assets/images/icon-edit-eye.png";
import icon02 from "@/assets/images/icon-edit-02.png";
import icon03 from "@/assets/images/icon-edit-03.png";
import icon04 from "@/assets/images/icons/ew-icon_published.png";
import icon05 from "@/assets/images/icons/Repeat Grid 2.png";
import icon06 from "@/assets/images/icons/ew-icon_hidden.png";
import icon07 from "@/assets/images/icons/ew-icon_add.png";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
export default {
  name: "visual-detail",
  components: {
    ExperiencePicker,
    PerfectScrollbar,
  },
  props: {
    moment: {
      type: Object,
      default() {
        return null;
      },
    },
    images: {
      type: Array,
      default: [],
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        help,
        icon01,
        icon02,
        icon03,
        icon04,
        icon05,
        icon06,
        icon07,
      },
    };
  },
  mounted() {
    this.addKeyUpEventHandler();
  },
  beforeDestroy() {
    this.removeKeyUpEventHandler();
  },
  methods: {
    updateStatus(status = "pending") {
      const moment = this.images[this.index];
      this.$repo.moment
        .batchUpdateMomentStatus([moment.id], status)
        .then((result) => {
          moment.status = status;
        });
    },
    onClickModalOverlay(e) {
      e.stopPropagation();
      this.close();
    },
    close() {
      this.$emit("closeDetail");
    },
    getHumanDate(date) {
      return moment(date).fromNow();
    },
    goPrevious() {
      this.$emit("goPrevious");
    },
    goNext() {
      this.$emit("goNext");
    },
    onKeyUpHandler(e) {
      e.preventDefault();

      switch (e.keyCode) {
        case 37:
        case 65:
        case 100:
          this.goPrevious();
          break;
        case 39:
        case 68:
        case 102:
          this.goNext();
          break;
        case 27:
          this.close();
          break;
      }
    },
    addKeyUpEventHandler() {
      document.addEventListener("keyup", this.onKeyUpHandler);
    },
    removeKeyUpEventHandler() {
      document.removeEventListener("keyup", this.onKeyUpHandler);
    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: $breakpoint-tablet) {
  #visual-detail {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;
    position: fixed;
    color: #58595b;
    display: flex;
    justify-content: center;
    align-items: center;
    .box-detail {
      font-size: 14px;
      position: relative;
      background-color: #fff;
      margin: 0 auto;
      width: 71.14%;
      min-height: 610px;
      max-height: 900px;
      padding: 20px 50px;
      .content-box {
        display: flex;
      }
      .description-box{
        padding-left: 3%;
        max-width: 50%;
      }
      .ps {
        height: 300px;
      }
      .report-link {
        color: #c53f3f;
      }

      .content-placeholder {
        flex: 1 1 auto;
      }

      .experience-btn {
        font-weight: normal;
        padding: 1%;
        background-color: #58595b;
        color: #ffffff;
      }

      .connected-experiences {
        p {
          color: #58595b;
          font-size: 14px;
          font-weight: 600;
        }
        span {
          font-weight: normal;
          margin-right: 0;
        }
      }

      .description {
        margin-bottom: 20px;
      }
      .description2 {
        margin-bottom: 30px;

        p {
          color: #58595b;
          font-size: 14px;
          line-height: 12px;
          font-weight: 600;
        }

        div {
          color: #58595b;
          font-size: 14px;
        }

        ul {
          list-style: none;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            color: #58595b;
            font-size: 14px;
          }
        }
      }

      .network-name {
        margin-bottom: 5px;
      }

      .img {
        max-height: 400px;
        text-align: center;
        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .author-picture {
        overflow: hidden;
        width: 43px;
        height: 43px;
        flex: 0 0 auto;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      .author-info {
        display: flex;
        align-items: center;
      }

      .author-name {
        font-weight: bold;
        flex: 1 1 auto;
      }
      .post-date {
        color: #b9b9b9;
      }

      .form-check-label {
        color: #58595b;
        font-size: 14px;
      }

      .update-status-buttons {
        display: flex;
        font-size: 14px;
        font-weight: normal;

        .btn {
          flex: 1 1 auto;

          & + .btn {
            margin-left: 5px;
          }
        }

        .btn-default {
          background-color: #b9b9b9;
        }

        .icon-button {
          height: 20px;
          padding-right: 10px;
          left: 0;
        }
      }

      .close {
        cursor: pointer;
        position: absolute;
        padding: 10px 20px;
        top: -6%;
        right: 24px;
        text-transform: uppercase;
        color: #ffffff;
        font-size: 12px;
        background-color: #555555;
        z-index: -1;
      }
    }
  }
}

@media screen and (max-width: $breakpoint-tablet-ipad) {
  #visual-detail {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;
    position: fixed;
    color: #58595b;
    justify-content: center;
    align-items: center;
    .box-detail {
      width: 71.14%;
      min-height: 610px;
      max-height: 900px;
      padding: 20px 50px;
      font-size: 14px;
      position: relative;
      background-color: #fff;
      margin: 0 auto;

      .ps {
        height: 300px;
      }
      .report-link {
        color: #c53f3f;
      }
      .img {
        text-align: center;
        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .author-picture {
        overflow: hidden;
        width: 43px;
        height: 43px;
        flex: 0 0 auto;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      .author-info {
        display: flex;
        align-items: center;
      }

      .author-name {
        font-weight: bold;
        flex: 1 1 auto;
      }

      .description {
        margin-bottom: 20px;
      }
      .description2 {
        margin-bottom: 30px;

        p {
          color: #58595b;
          font-size: 14px;
          line-height: 12px;
          font-weight: 600;
        }

        div {
          color: #58595b;
          font-size: 14px;
        }

        ul {
          list-style: none;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            color: #58595b;
            font-size: 14px;
          }
        }
      }

      .update-status-buttons {
        display: flex;
        font-size: 14px;
        font-weight: normal;

        .btn {
          flex: 1 1 auto;

          & + .btn {
            margin-left: 5px;
          }
        }

        .btn-default {
          background-color: #b9b9b9;
        }

        .icon-button {
          height: 16px;
          padding-right: 10px;
          left: 0;
        }
      }

      .close {
        cursor: pointer;
        position: absolute;
        padding: 10px 20px;
        top: -4%;
        right: 24px;
        text-transform: uppercase;
        color: #ffffff;
        font-size: 12px;
        background-color: #555555;
        z-index: -1;
      }
    }
  }
}

@media screen and (max-width: $breakpoint-phone) {
  #visual-detail {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;
    position: fixed;
    color: #58595b;
    display: flex;
    justify-content: center;
    align-items: center;
    .box-detail {
      width: 80%;
      min-height: 400px;
      max-height: 600px;
      padding: 20px 20px;
      font-size: 14px;
      position: relative;
      background-color: #fff;
      margin: 0 auto;
      .ps {
        height: 200px;
      }
      .report-link {
        color: #c53f3f;
      }
      .content-box {
        align-content: center;
      }

      .img {
        max-height: 400px;
        text-align: center;
        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
      .img {
        margin: 0;
        height: 156.05px;
        text-align: center;
        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .author-picture {
        overflow: hidden;
        width: 43px;
        height: 43px;
        flex: 0 0 auto;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      .author-info {
        display: flex;
        align-items: center;
      }

      .author-name {
        font-weight: bold;
        flex: 1 1 auto;
      }

      .description {
        margin-bottom: 20px;
      }
      .description2 {
        margin-bottom: 30px;

        .ps {
          max-height: 180px;
          max-width: 400px;

          .ps__rail-y {
            opacity: 0.6;
          }
        }

        p {
          color: #58595b;
          font-size: 14px;
          line-height: 12px;
          font-weight: 600;
        }

        div {
          color: #58595b;
          font-size: 14px;
        }

        ul {
          list-style: none;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            color: #58595b;
            font-size: 14px;
          }
        }
      }

      .update-status-buttons {
        display: table-row;
        margin-left: auto;
        margin-right: auto;
        font-size: 14px;
        font-weight: normal;

        .btn {
          flex: 1 1 auto;

          & + .btn {
            margin-top: 3%;
            margin-left: auto;
            margin-right: auto;
          }
        }

        .btn-default {
          background-color: #b9b9b9;
        }

        .icon-button {
          height: 10px;
          padding-right: 2px;
          left: 0;
        }
      }

      .close {
        cursor: pointer;
        position: absolute;
        padding: 10px 20px;
        top: -5%;
        right: 24px;
        text-transform: uppercase;
        color: #ffffff;
        font-size: 12px;
        background-color: #555555;
        z-index: -1;
      }
    }
  }
}
</style>
